import React, { useState, useEffect } from 'react'
import Portal from '../Portal'
import { Container, FullContainer } from './styles'
import Icon from '../Icon'

interface LoaderProps {
  full?: boolean
  darkMode?: boolean
  delay?: number
  imageStyle?: any
}

const Loader: React.FC<LoaderProps> = ({
  full = false,
  darkMode = false,
  delay = 2500,
  imageStyle,
}) => {
  const [shouldShow, setShouldShow] = useState<boolean>(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldShow(true)
    }, delay)

    return () => window.clearTimeout(timeout)
  }, [shouldShow, delay])

  if (!shouldShow) {
    return null
  }

  const L = (
    <Container>
      <Icon
        style={{ ...imageStyle }}
        name={darkMode ? 'dark-loader' : 'loader'}
      />
    </Container>
  )

  if (full) {
    return (
      <Portal
        id="loader-root"
      >
        <FullContainer>
          {L}
        </FullContainer>
      </Portal>
    )
  }

  return L
}

export default Loader
